import type { FormEvent } from "react";

export type OnMetricChangeFn = (
  newValue: FormEvent<HTMLInputElement | HTMLTextAreaElement> | string,
  nonDetect?: boolean,
  comment?: string,
) => void;

export enum InputMode {
  Normal,
  Loading,
  SiteEdit,
  ReadOnly,
}

export type MetricInputProps = {
  id: number;
  value?: string | null;
  mode: InputMode;
  isDirty: boolean;
  onChange: OnMetricChangeFn;
};
